import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import utils from 'utils';
import { actionType, modalActionType } from 'utils/constants';

import CommonButton from 'components/Buttons/CommonButton';
import selectors from 'state/selectors';
import actions from 'state/actions';
import services from 'services';
import axios from 'axios';

const DeleteOverdueotification = () => {
  const t = utils.intl.useTranslator();
  const dispatch = useDispatch();

  const selectedRow = useSelector(selectors.configurator.getSelectedOverdueSettings);
  const rows = useSelector(selectors.configurator.getListOfOverdueSettings);
  const formMode = useSelector(selectors.configurator.getFormModeOverdue);

  const deleteRow = async () => {
    if (!selectedRow) return;
    try {
      await services.deleteOverdueNotificationSettings(selectedRow?.idUser);
      dispatch(
        actions.configurator.setListOfOverdueSettings(
          (rows as any[]).filter((row) => row.idUser !== selectedRow?.idUser),
        ),
      );
      utils.app.notify('success', t('delete_overdue_success'));
    } catch (error) {
      if (axios.isAxiosError(error)) {
        utils.app.notify('fail', `${t('error')} ${error.response}`);
        return;
      }
      console.error(error);
    } finally {
      dispatch(actions.modal.closeModal());
    }
  };

  return (
    <CommonButton
      id="delete-overdue-notification"
      action={() =>
        dispatch(
          actions.modal.setModal({
            actionType: modalActionType.configurator.DELETE_CONFIRMATION,
            props: {
              subtitle: t('delete-overdue-setting'),
              func: async () => await deleteRow(),
            },
          }),
        )
      }
      scope="tertiary"
      value={t(actionType.DELETE_OVERDUE_NOTIFICATION)}
      customIcon="trash"
      disabled={
        !utils.user.isActionByCompanyActive(actionType.DELETE_OVERDUE_NOTIFICATION) || !selectedRow || !!formMode
      }
    />
  );
};

export default DeleteOverdueotification;
